import script from "./LoginTemporaryPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginTemporaryPassword.vue?vue&type=script&setup=true&lang=ts"

import "./LoginTemporaryPassword.vue?vue&type=style&index=0&id=2e13a520&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e13a520"]])

export default __exports__